import consumer from "./consumer";

const $conferencePage = $("#conference-page");
const isLiveSessionPage =
  $conferencePage.length > 0 && $conferencePage.data("liveSession") === true;

(function () {
  if (!isLiveSessionPage) return;

  let intervalTimer;
  let liveSessionStarted = false;

  const $timer = $("#timer");
  const $connectionControl = $(".connection-control");

  const roomID = $conferencePage.data("conference-room-id");
  const displayName = $conferencePage.data("display-name");
  const isLiveOwner =
    $conferencePage.attr("data-live-owner") === "true";
  const expiresAtMsRaw = $conferencePage.attr("data-live-expires-at-ms");
  const expiresAtMs = expiresAtMsRaw
    ? parseInt(expiresAtMsRaw, 10)
    : 0;

  const startsAtMsRaw = $conferencePage.attr("data-live-starts-at-ms");
  const startsAtMs = startsAtMsRaw ? parseInt(startsAtMsRaw, 10) : 0;

  function elapsedSecondsSinceLiveStart() {
    if (!startsAtMs) return 0;
    return Math.max(0, Math.floor((Date.now() - startsAtMs) / 1000));
  }

  const authenticityToken = document
    .querySelector('meta[name="csrf-token"]')
    .getAttribute("content");

  let liveSessionLeft = false;
  let finalizeRequested = false;

  function leaveLiveSessionUi() {
    if (liveSessionLeft) return;
    liveSessionLeft = true;
    try {
      if (typeof api !== "undefined" && api) {
        api.dispose();
      }
    } catch (e) {
      /* ignore */
    }
    window.location.href = "/";
  }

  /**
   * Grava a live como terminada na app e redireciona.
   * @param {object} opts
   * @param {boolean} [opts.skipEndConference] — se true, não chama endConference (Jitsi já terminou, ex.: botão "Terminar para todos").
   */
  function finalizeLiveSession(opts = {}) {
    const skipEndConference = opts.skipEndConference === true;
    if (finalizeRequested || liveSessionLeft) return;
    finalizeRequested = true;

    if (!skipEndConference) {
      try {
        if (typeof api !== "undefined" && api && typeof api.executeCommand === "function") {
          api.executeCommand("endConference");
        }
      } catch (e) {
        /* ignore — fallback: POST + dispose */
      }
    }

    $.post(`/live/${roomID}/finish`, {
      authenticity_token: authenticityToken,
    }).always(function () {
      leaveLiveSessionUi();
    });
  }

  function secondsTimeSpanToHMS(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    return `${hours}:${minutes < 10 ? "0" : ""}${minutes}:${
      remainingSeconds < 10 ? "0" : ""
    }${remainingSeconds}`;
  }

  function setVisibility($element, isVisible) {
    isVisible ? $element.show() : $element.hide();
  }

  function remoteParticipantCount(api) {
    const all = api.getParticipantsInfo();
    return all.filter((p) => p.participantId !== "local").length;
  }

  function liveElapsedTimer() {
    clearInterval(intervalTimer);

    function tick() {
      const elapsed = elapsedSecondsSinceLiveStart();
      $timer.html(secondsTimeSpanToHMS(elapsed));

      if (expiresAtMs > 0 && Date.now() >= expiresAtMs) {
        clearInterval(intervalTimer);
        if (isLiveOwner) {
          finalizeLiveSession();
        } else {
          leaveLiveSessionUi();
        }
      }
    }

    tick();
    intervalTimer = setInterval(tick, 1000);
  }

  function actionStartLiveSession() {
    if (liveSessionStarted) return;
    liveSessionStarted = true;

    setVisibility($timer, true);
    setVisibility($connectionControl, true);
    liveElapsedTimer();
  }

  const domain = "meet.helpcam.com";
  const tokenJWT = window.jitsiToken;
  const roomName = `helpcam-live-${roomID}`;

  /** Dono: toolbar completa + moderador no JWT. Convidados: só áudio, câmara, ruído, ecrã inteiro, vista e sair. */
  const toolbarButtonsLiveOwner = [
    "microphone",
    "camera",
    "desktop",
    "tileview",
    "fullscreen",
    "highlight",
    "participants-pane",
    "noisesuppression",
    "select-background",
    "shareaudio",
    "sharedvideo",
    "toggle-camera",
    "hangup",
  ];

  const toolbarButtonsLiveGuest = [
    "microphone",
    "camera",
    "noisesuppression",
    "fullscreen",
    "tileview",
    "hangup",
  ];

  const options = {
    roomName: roomName,
    width: "100%",
    height: "100%",
    parentNode: document.querySelector("#jitsi-container"),
    userInfo: {
      displayName: displayName,
    },
    configOverwrite: {
      requireTokenAuth: true,
      startWithAudioMuted: false,
      disableProfile: true,
      disableModeratorIndicator: false,
      prejoinConfig: {
        enabled: true,
        hideExtraJoinButtons: ["no-audio"],
      },
      conferenceInfo: {
        autoHide: [],
      },
      hideConferenceSubject: "",
      gravatar: {
        disabled: true,
      },
      deeplinking: { disabled: true },
      disableDeepLinking: true,
      enableWelcomePage: false,
      ...(isLiveOwner
        ? {}
        : {
            participantsPane: {
              hideMuteAllButton: true,
              hideModeratorSettingsTab: true,
              hideMoreActionsButton: true,
            },
          }),
      toolbarButtons: isLiveOwner
        ? toolbarButtonsLiveOwner
        : toolbarButtonsLiveGuest,
      // Convidados: interceptamos o hangup para redirecionar à app.
      // Moderadores: deixar o Jitsi mostrar o menu nativo (Sair vs Terminar para todos) e notificar cliques.
      buttonsWithNotifyClick: isLiveOwner
        ? [
            { key: "hangup", preventExecution: false },
            { key: "hangup-menu", preventExecution: false },
            { key: "end-meeting", preventExecution: false },
          ]
        : [
            { key: "hangup", preventExecution: true },
            { key: "hangup-menu", preventExecution: true },
          ],
    },
    interfaceConfigOverwrite: {
      HIDE_NO_AUDIO_OPTION: true,
      HIDE_ROOMNAME_ON_JOIN: true,
      SHOW_JITSI_WATERMARK: false,
      SHOW_WATERMARK_FOR_GUESTS: false,
      DEFAULT_BACKGROUND: "#1F9EDE",
    },
    jwt: tokenJWT,
    lang: "ptBR",
  };

  const api = new JitsiMeetExternalAPI(domain, options);

  /** Supressão de ruído desativada ao entrar; o utilizador pode ativar na toolbar. */
  function applyDefaultNoiseSuppression() {
    try {
      api.executeCommand("setNoiseSuppressionEnabled", { enabled: false });
    } catch (e) {
      /* ignore */
    }
  }

  consumer.subscriptions.create(
    { channel: "LiveSessionChannel", room_id: roomID },
    {
      received(data) {
        if (data && data.action === "ended") {
          leaveLiveSessionUi();
        }
      },
    }
  );

  api.on("toolbarButtonClicked", ({ key }) => {
    if (!isLiveOwner) {
      if (key === "hangup" || key === "hangup-menu") {
        leaveLiveSessionUi();
      }
      return;
    }

    // Moderador: menu nativo Jitsi — "Leave" usa key hangup; "End meeting for all" usa end-meeting (iframe API).
    if (key === "end-meeting") {
      finalizeLiveSession({ skipEndConference: true });
    }
  });

  api.on("readyToClose", () => {
    if (liveSessionLeft) return;
    // Convidado: sair para a app. Moderador que só saiu (hangup): idem. Moderador que já disparou finalizeLiveSession vê liveSessionLeft.
    leaveLiveSessionUi();
  });

  api.on("videoConferenceJoined", () => {
    applyDefaultNoiseSuppression();
    setTimeout(applyDefaultNoiseSuppression, 800);

    actionStartLiveSession();

    setTimeout(() => {
      const n = remoteParticipantCount(api);
      if (n >= 1) {
        setVisibility($connectionControl, false);
      }
    }, 400);
  });

  api.on("participantJoined", () => {
    const n = remoteParticipantCount(api);
    if (n >= 1) {
      setVisibility($connectionControl, false);
    }
  });
})();
